import { render, staticRenderFns } from "./AddNewColor.vue?vue&type=template&id=48991721&scoped=true"
import script from "./AddNewColor.vue?vue&type=script&lang=js"
export * from "./AddNewColor.vue?vue&type=script&lang=js"
import style0 from "./AddNewColor.vue?vue&type=style&index=0&id=48991721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48991721",
  null
  
)

export default component.exports